'use client';

// This import must go at the top
import 'lib/http/setup';

import { HotkeyProvider } from '@mentimeter/hotkeys';
import { DeviceProvider } from '@mentimeter/ragnar-device';
import { stripAllNonNumericChars } from '@mentimeter/ragnar-utils';
import { SSEProvider } from '@mentimeter/server-sent-events';
import { ToastsProvider } from '@mentimeter/toast';
import { parseAndStoreUtmParams } from '@mentimeter/utm';
import { store } from 'features/core/edit_view/store/configureStore';
import { useEffect } from 'react';
import { ThemeProvider } from 'react-fela'; // keep import from react-fela to avoid getting Tailwind theme twice
import { Provider as ReduxProvider } from 'react-redux';
import {
  createDscFromThemeSetting,
  getUITheme,
} from '@mentimeter/ragnar-ui/themes';
import { FelaProvider } from './FelaProvider';
import { RegionalProvider } from './RegionalProvider';
import { MobileMenuProvider } from './MobileMenuProvider';

export function Providers({ children }: { children: React.ReactNode }) {
  const uiTheme = getUITheme();

  const { theme } = createDscFromThemeSetting(uiTheme);

  const breakpoints = theme.breakpoints.map((b) => stripAllNonNumericChars(b));

  useEffect(() => {
    parseAndStoreUtmParams(document.URL);
  }, []);

  return (
    <DeviceProvider breakpoints={breakpoints}>
      <ThemeProvider theme={theme}>
        <MobileMenuProvider>
          <FelaProvider>
            <HotkeyProvider>
              <RegionalProvider>
                <SSEProvider>
                  <ToastsProvider>
                    <ReduxProvider store={store}>{children}</ReduxProvider>
                  </ToastsProvider>
                </SSEProvider>
              </RegionalProvider>
            </HotkeyProvider>
          </FelaProvider>
        </MobileMenuProvider>
      </ThemeProvider>
    </DeviceProvider>
  );
}
